export default {
  init() {
    this.runSmoothScroll();
    this.runWhatsTrendingSlider();
    this.runEntertainmentSlider();
    this.runDecorationsSlider();
    this.runFoodAndServiceSlider();
    this.runOutdoorSlider();

    $('.js-explore-dropdown').change(evt => {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(`#${evt.currentTarget.value}`).offset().top - $('.MainHeader').height(),
      }, 1500);
    });
  },

  runSmoothScroll() {
    $('.wedding-reception__explore-link').click(function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $('#' + $(this).attr('scroll')).offset().top,
      }, 1500);
    });
  },

  // whats trending slider
  runWhatsTrendingSlider() {
    $('.wedding-reception__whats-trending .category-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },

  // entertainment slider
  runEntertainmentSlider() {
    $('.wedding-reception__entertainment .category-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },

  //
  runDecorationsSlider() {
    $('.category__decorations .category-slider').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            variableWidth: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    });
  },

  //
  runFoodAndServiceSlider() {
    $('.category__food-and-service .category-slider').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            variableWidth: false,
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
          },
        },
      ],
    });
  },

  //
  runOutdoorSlider() {
    $('.category__outdoor .category-slider').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            variableWidth: false,
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
          },
        },
      ],
    });
  },

  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/category.js